import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/css';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initialize() {   
    const containerId = '.container-slider-categories';

    new Swiper(containerId + ' #slider-categories', {
        modules: [Navigation, Pagination, Scrollbar],

        slidesPerView: 6,
        spaceBetween: 5,

        breakpoints: {
            0: {
                slidesPerView: 3,
            },
            //sm
            640: {
                slidesPerView: 3,
            },
            //lg
            1024: {
                slidesPerView: 5,
            },
            //xl
            1280: {
                slidesPerView: 6,
            },
        },

        navigation: {
            prevEl: containerId + ' #slider-categories .btn-prev',
            nextEl: containerId + ' #slider-categories .btn-next',
        },

        pagination: {
            el: containerId + ' .swiper-pagination',
            type: 'progressbar',
        },

        on: {
            init: function () {
                if (this.isLocked) {
                    $(containerId).find('.slider-pager-pager').addClass('hidden');
                }
            },
        },
    });
}

initialize();
